module.exports = __webpack_public_path__ + "img/signal.96723e94.webp";